module.exports = __webpack_public_path__ + "img/422.f9a6172f.jpg";